import { getValidationSchema } from "@Shared/utils/validationSchema";
import * as yup from "yup";
import tmkKeyFormMeta, { ITmkKeyFormMeta } from "./TMKFormMeta";
import tpkKeyFormMeta, { ITpkKeyFormMeta } from "./TPKFormMeta";

export interface IKeysFormMeta extends ITpkKeyFormMeta, ITmkKeyFormMeta {
  
  schema: any;
}

let keysFormMeta = {} as IKeysFormMeta;

keysFormMeta = { ...keysFormMeta, ...tpkKeyFormMeta, ...tmkKeyFormMeta };

keysFormMeta.schema = yup.object().shape(getValidationSchema(keysFormMeta));

export default keysFormMeta;